'use client'

import { useState } from 'react'
import { Icon } from '@/components/icon'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type ShareButtonProps = {
  url?: string
  variant?: 'default' | 'player'
}

export function ShareButton({ url, variant = 'default' }: ShareButtonProps) {
  const [isCopied, setIsCopied] = useState(false)

  const copyToClipboard = () => {
    const shareUrl = url ?? window.location.href
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        setIsCopied(true)
        setTimeout(() => {
          setIsCopied(false)
        }, 1000)
      })
      .catch((error) => {
        console.error(error.name, error.message)
      })
  }

  if (variant === 'player') {
    return (
      <div className='relative'>
        <Button
          variant='ghost'
          className='relative flex h-auto items-center gap-2 bg-christ-white-700/20 px-4 py-2.5 pb-1.5 font-extrabold font-formula-condensed font-stylistic-set text-[1.25rem] uppercase transition-all hover:bg-christ-white-700/30'
          onClick={copyToClipboard}
          disabled={isCopied}
        >
          <Icon name='link' className='size-4 max-w-4' />
          <span>Share</span>
        </Button>
        <span
          className={cn(
            'pointer-events-none absolute top-full left-1/2 z-100 mt-2 w-max -translate-x-1/2 rounded bg-black/90 px-2 py-1.5 text-[0.85rem] leading-none opacity-0',
            isCopied && 'animate-[copied_1s_cubic-bezier(0.4,0,0.2,1)_1_normal_forwards]',
          )}
        >
          Link copied
        </span>
      </div>
    )
  }

  return (
    <div className='relative'>
      <Button
        variant='ghost'
        className='relative flex h-auto items-center gap-2 p-0 font-light uppercase transition-opacity hover:opacity-90'
        onClick={copyToClipboard}
        disabled={isCopied}
      >
        <Icon name='link' className='size-4 max-w-4' />
        <span className='relative top-[0.1rem]'>Share</span>
      </Button>
      <span
        className={cn(
          'pointer-events-none absolute top-0 left-0 z-100 w-max bg-black px-1.5 py-1.5 pb-1 text-[0.85rem] leading-none opacity-0 max-[1024px]:right-auto max-[1366px]:right-0 max-[1024px]:left-0 max-[1366px]:left-auto',
          isCopied && 'animate-[copied_1s_cubic-bezier(0.4,0,0.2,1)_1_normal_forwards]',
        )}
      >
        Link copied
      </span>
    </div>
  )
}
